import { useRouteLoaderData, useLocation } from '@remix-run/react'
import { useEffect } from 'react'
import { RootDataProps } from '~/types'
import { trackPageInfo, isGtmLoaded } from '~/utils'

export interface PageInfoHookProps {
  pageType: string
  pageTitle?: string
  categoryType?: string
  categoryTitle?: string
  categoryParentTitle?: string
}

const usePageInfo = ({
  pageType,
  pageTitle,
  categoryType,
  categoryTitle,
  categoryParentTitle,
}: PageInfoHookProps) => {
  // Global user data
  const location = useLocation()
  const { user } = useRouteLoaderData('root') as RootDataProps

  // On load populate the data layer
  useEffect(() => {
    if (!pageType) return

    let timesRun = 0

    const interval = setInterval(() => {
      timesRun += 1

      if (isGtmLoaded() || timesRun === 5) {
        clearInterval(interval)
      }

      trackPageInfo({
        pageType,
        pageTitle,
        categoryType,
        categoryTitle,
        categoryParentTitle,
        loggedIn: user ? true : false,
      })
    }, 1000)

    // @NOTE: ONLY USE THE BELOW IF YOU ARE SURE
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])
}

export default usePageInfo
